module.exports = __webpack_public_path__ + "img/folder-layer.d2140c81.svg";